export const tr = {
  title: "Hotspot'a Bağlan",
  verificationTitle: "Doğrulama Yöntemi Seçin",
  methods: {
    sms: {
      label: "SMS ile Doğrula",
      firstName: {
        label: "İsim",
        placeholder: "Adınızı girin"
      },
      lastName: {
        label: "Soyisim",
        placeholder: "Soyadınızı girin"
      },
      phone: {
        label: "Telefon Numarası",
        placeholder: "539 XXX XX XX"
      }
    },
    tc: {
      label: "TC Kimlik",
      firstName: {
        label: "İsim",
        placeholder: "Adınızı girin"
      },
      lastName: {
        label: "Soyisim",
        placeholder: "Soyadınızı girin"
      },
      idNumber: {
        label: "T.C. Kimlik Numarası",
        placeholder: "11111111111"
      },
      birthYear: {
        label: "Doğum Yılı",
        placeholder: "1990"
      }
    },
    whatsapp: {
      label: "WhatsApp",
      firstName: {
        label: "İsim",
        placeholder: "Adınızı girin"
      },
      lastName: {
        label: "Soyisim",
        placeholder: "Soyadınızı girin"
      },
      phone: {
        label: "WhatsApp Numarası",
        placeholder: "539 XXX XX XX"
      }
    },
    telegram: {
      label: "Telegram",
      inputLabel: "Telegram Kullanıcı Adı",
      placeholder: "@kullaniciadi"
    },
    login: {
      label: "Kullanıcı Adı / Şifre",
      username: {
        label: "Kullanıcı Adı",
        placeholder: "Kullanıcı adınızı girin"
      },
      password: {
        label: "Şifre",
        placeholder: "Şifrenizi girin"
      }
    }
  },
  errors: {
    required: "Bu alan boş bırakılamaz"
  },
  buttons: {
    submit: "Gönder ve Bağlan",
    language: "English",
    sendPin: "PIN Gönder",
    verifyPin: "PIN Doğrula"
  },
  socialMedia: {
    follow: "Bizi Takip Edin",
    instagram: "Instagram'da Takip Et",
    facebook: "Facebook'ta Takip Et",
    twitter: "Twitter'da Takip Et"
  },
  businessInfo: {
    welcome: "Hoş Geldiniz",
    openHours: "Çalışma Saatleri: 09:00 - 23:00",
    address: "Adres: Örnek Mahallesi, Örnek Sokak No:123",
    phone: "Tel: +90 212 XXX XX XX"
  }
}; 